module.exports = __webpack_public_path__ + "img/householdequipment2.582e475a.png";